import { type WalletLedgerSummaryFundUsageDetails } from '@capsicum/common';
import { useCallback } from 'react';

import { useLedgerSummaryByIdQuery } from '../data-access';
import { type WalletLedgerSummaryInfo } from '../models';

type InUseData = {
	inUseBalanceData?: number | string;
	inUseDetailsData?: Array<WalletLedgerSummaryFundUsageDetails>;
};

/**
 * @returns An array of in use detail objects from the ledger data.
 */
export const useLedgerSummaryInUseDetails = (ledgerId: string) => {
	const walletLedgerSummaryInUseDetailsReducer = useCallback(
		(data: undefined | WalletLedgerSummaryInfo): InUseData => {
			return {
				inUseBalanceData: data?.inUseBalance || 0,
				inUseDetailsData: data?.inUseDetails || []
			};
		},
		[]
	);
	const {
		data: ledgerSummary,
		error,
		isLoading,
		refetch
	} = useLedgerSummaryByIdQuery(ledgerId, walletLedgerSummaryInUseDetailsReducer);
	const inUseDetails = ledgerSummary! || [];

	return { error, inUseDetails, isLoading, refetch };
};
